import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout/Layout';

const TestPage = () => {
  console.log('🧪 TestPage: Renderizando página de teste');
  const { user, logout, isAuthenticated, loading } = useAuth();

  return (
    <Layout>
      <Box sx={{
        p: 3,
        maxWidth: '1200px',
        mx: 'auto',
        width: '100%'
      }}>
        <Typography variant="h3" gutterBottom>
          🧪 Página de Teste
        </Typography>

        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h5" gutterBottom>
            Status da Autenticação:
          </Typography>
          <Typography>🔐 Loading: {loading ? 'true' : 'false'}</Typography>
          <Typography>🔐 isAuthenticated: {isAuthenticated ? 'true' : 'false'}</Typography>
          <Typography>👤 User: {user?.name || 'Não autenticado'}</Typography>
          <Typography>🔑 Token: {user ? 'Presente' : 'Ausente'}</Typography>
        </Paper>

        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h5" gutterBottom>
            Ações de Teste:
          </Typography>
          <Button variant="contained" onClick={() => console.log('Auth state:', { user, isAuthenticated, loading })}>
            Log Auth State
          </Button>
          <Button variant="outlined" onClick={logout} sx={{ ml: 2 }}>
            Logout
          </Button>
        </Paper>

        <Paper sx={{ p: 3 }}>
          <Typography variant="h5" gutterBottom>
            Teste de API:
          </Typography>
          <Button
            variant="contained"
            onClick={async () => {
              try {
                console.log('🧪 TestPage: Testando API...');
                const response = await fetch('http://localhost:3002/api/health');
                const data = await response.json();
                console.log('🧪 TestPage: Resposta da API:', data);
                alert('API funcionando! Veja o console para detalhes.');
              } catch (error) {
                console.error('🧪 TestPage: Erro na API:', error);
                alert('Erro na API! Veja o console para detalhes.');
              }
            }}
          >
            Testar API Backend
          </Button>
        </Paper>
      </Box>
    </Layout>
  );
};

export default TestPage;
